import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import IconPaperplaneOutline from '@adv-mt/mt-svg-icons/lib/PaperplaneOutline'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Body1, Headline2} from '@adv-mt/ui/typography'

import {useContactCardInput, useContactSellerV2Config} from '../context/ContactSellerV2Context.js'
import {useFormContext} from '../form/formContexts.js'
import AlertsCheckbox from './AlertsCheckbox.js'
import BuyerIntentions, {hasBuyerIntentions} from './BuyerIntentions.js'
import {useContactFormContext} from './ContactFormContext.js'
import ContactingAs from './ContactingAs.js'
import FormFields, {BASE_CLASS} from './FormFields.js'
import TermsField from './TermsField.js'

export const getMessageTitleKey = appName => `CONTACT_SELLER_V2.FORM.MESSAGE_TITLE_${appName}`

const ContactBody = ({buttonGroup, showMessageTitle = true, beforeSubmit}) => {
  const {i18n, domain} = useContext(Context)
  const appName = domain.get('config').get('APP_NAME')
  const form = useFormContext()
  const {pageName, isPrivateSeller = false} = useContactSellerV2Config()
  const {
    enableAlertCreation = false,
    buyerIntentions = [],
    isLeadEnrichmentEnabled = false,
    isVOorVNorKM0 = false,
    userData
  } = useContactCardInput()
  const {hasTermsAlert = false} = useContactFormContext()

  const showsBuyerIntentions = hasBuyerIntentions({
    buyerIntentions,
    isLeadEnrichmentEnabled,
    isVOorVNorKM0,
    isPrivateSeller
  })

  return (
    <div className={`${BASE_CLASS}-body`}>
      {buttonGroup}
      {Boolean(buttonGroup) && (
        <div className={`${BASE_CLASS}-divider`}>
          <Body1 as="span" className={`${BASE_CLASS}-dividerLabel`}>
            {i18n.t('CONTACT_SELLER_V2.FORM.DIVIDER_OR')}
          </Body1>
        </div>
      )}

      {showMessageTitle && (
        <Headline2 as="p" className={`${BASE_CLASS}-messageTitle`}>
          {i18n.t(getMessageTitleKey(appName))}
        </Headline2>
      )}

      <BuyerIntentions />

      <FormFields showCommentLabel={!showsBuyerIntentions} />

      <ContactingAs userData={userData} />

      <div className={`${BASE_CLASS}-checks`}>
        {!userData && <TermsField hasAlert={hasTermsAlert} />}
        {enableAlertCreation && <AlertsCheckbox pageName={pageName} />}
      </div>

      {beforeSubmit}

      <div className={`${BASE_CLASS}-submit`}>
        <form.Subscribe selector={state => state.isSubmitting}>
          {isSubmitting => (
            <Button
              type="submit"
              formNoValidate
              variant={BUTTON_VARIANTS.SOLID}
              intent={BUTTON_INTENTS.ACCENT}
              size={BUTTON_SIZES.LARGE}
              shape={BUTTON_SHAPES.CIRCLE}
              fullWidth
              isLoading={isSubmitting}
            >
              <IconPaperplaneOutline size={ATOM_ICON_SIZES.medium} />
              {i18n.t('CONTACT_SELLER_V2.FORM.SUBMIT_CTA')}
            </Button>
          )}
        </form.Subscribe>
      </div>
    </div>
  )
}

ContactBody.displayName = 'ContactFormV2ContactBody'

ContactBody.propTypes = {
  buttonGroup: PropTypes.node,
  showMessageTitle: PropTypes.bool,
  beforeSubmit: PropTypes.node
}

export default ContactBody
